import Vue from 'vue';
import Component from 'vue-class-component';
import { G2S } from 'core/g2s';
import router from 'src/router';
import * as api from 'core/api';
import * as auth from 'core/auth';
import * as utils from 'core/utils';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class SupportListComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init

    view = 'loading';

    gaParams: utils.GoogleAnalyticsParams = new utils.GoogleAnalyticsParams();

    reservationsSupportInfo?: api.ReservationSupportInfo[];

    selectedReservationSupportInfo: api.ReservationSupportInfo | null = null;

    mounted() {
        if (this.$auth.authenticated) {
            this.loadModel();
        } else {
            this.$nextTick(() => {
                if (this.$route.query.token) {
                    // If token in url the try to confirm user
                    this.$auth.confirm(<string>this.$route.query.token).then(
                        (result: api.User) => {
                            if (result.hasPassword) {
                                this.loadModel();
                            } else {
                                this.openAuthForm();
                            }
                        },
                        () => {
                            this.openAuthForm();
                        }
                    );
                } else {
                    this.openAuthForm();
                }
            });
        }
    }

    loadModel() {
        const marketCode = G2S.config.marketCode;
        const locale = G2S.config.locale;

        new api.SupportService().getReservationsSupportInformation(marketCode, locale).then(
            (result: api.SupportGetReservationsSupportInformationResult) => {
                this.reservationsSupportInfo = result.reservationsSupportInfo;

                this.view = 'view';
            },
            (error) => {
                if (error.response) {
                    console.log('XHR failed', error.response.status, error.response.data);
                } else {
                    console.log('XHR error', error.message);
                }
            }
        );
    }

    openAuthForm() {
        if (<string>this.$route.query.auth === 'phone') {
            (<any>this.$root.$refs).signInPanel.onSignInByOneTimePassword();
        } else {
            (<any>this.$root.$refs).signInPanel.onSignIn();
        }
    }

    openStatus(info: api.ReservationSupportInfo) {
        if (!info.ticketExist) {
            (<any>this).$ga.sendEvent('account', 'shown.popup', 'shown.popup.no.refund.requests', this.gaParams);
        }

        this.selectedReservationSupportInfo = info;
        (<any>this.$refs).modalStatus.isActive = true;
    }
}
